import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7799619e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cookie-consent" }
const _hoisted_2 = { class: "nav" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_translate = _resolveDirective("translate")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("h4", null, null, 512), [
      [_directive_translate, `cookie.consent_title`]
    ]),
    _withDirectives(_createElementVNode("p", null, null, 512), [
      [_directive_translate, `cookie.consent_message`]
    ]),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("button", {
        type: "button",
        role: "button",
        class: "btn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.submit(false)))
      }, null, 512), [
        [_directive_translate, `general.decline`]
      ]),
      _withDirectives(_createElementVNode("button", {
        type: "button",
        role: "button",
        class: "btn",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.submit(true)))
      }, null, 512), [
        [_directive_translate, `general.accept`]
      ])
    ])
  ], 512)), [
    [_vShow, _ctx.show]
  ])
}